import { PriceEstimate } from 'src/components/ProductDetail/utils/product-detail.types';
import { ApplicationMethod } from 'src/components/CustomisationPage/feature/customisation.types';

export type Prices = {
    embroideryItemPrice: number;
    embroideryTotalPrice: number;
    printItemPrice: number;
    printTotalPrice: number;
};
export function getPriceEstimates(
    priceEstimates: PriceEstimate[],
    qtySelected: number,
    itemPrice: number,
    vat: boolean,
): Prices {
    const embroideryPrices = priceEstimates.filter((p) => p.type === ApplicationMethod.Embroidery);
    const printPrices = priceEstimates.filter((p) => p.type === ApplicationMethod.Print);
    const embroideryItemPrice = rangeMatch(embroideryPrices, qtySelected, vat);
    const printItemPrice = rangeMatch(printPrices, qtySelected, vat);
    return {
        embroideryItemPrice: embroideryItemPrice,
        embroideryTotalPrice: qtySelected * (embroideryItemPrice + itemPrice),
        printItemPrice: printItemPrice,
        printTotalPrice: qtySelected * (printItemPrice + itemPrice),
    };
}

export function rangeMatch(items: PriceEstimate[], qty: number, vat: boolean): number {
    items.sort((a, b) => (a.min_qty > b.min_qty ? 1 : -1));
    const match = items.find((item, index) => {
        const next = items[index + 1];
        const nextQty = (next && next.min_qty) ?? Infinity;
        return qty >= item.min_qty && qty < nextQty;
    });
    if (!match) return 0;
    return vat ? match.price_incl : match.price;
}
